import { configAxiosFormData, configAxiosNoCamelCase, configAxiosNoCamelCase2 } from '@/utils/api-instance';
import { ENDPOINTS } from '@/utils/constants';
import b64toBlob from 'b64-to-blob';
import { xml2json } from '@/utils/xml2json';
let api;
export const saveFiles = async base64DataArray => {
    const awsCredentials = await getPresigned();

    const fileSubmitPromises = base64DataArray.map(async file => saveFile(file, awsCredentials));
    return Promise.all(fileSubmitPromises);
};

export const saveFiles2 = async base64DataArray => {
    const awsCredentials = await getPresigned2();

    const fileSubmitPromises = base64DataArray.map(async file => saveFile(file, awsCredentials));
    return Promise.all(fileSubmitPromises);
};

export const getPresigned = async () => {
    api = configAxiosNoCamelCase();
    const { data } = await api.get(ENDPOINTS.S3_PRESIGNED);
    return data;
};

export const getPresigned2 = async () => {
    api = configAxiosNoCamelCase2();
    const { data } = await api.get(ENDPOINTS.S3_PRESIGNED);
    return data;
};

export const saveFile = async (base64Data, awsCredentials) => {
    const filePayload = formatBase64(base64Data.file);
    const contentType = getFileMime(base64Data.file);

    const fullFileName = base64Data.file_name;
    const fileExtension = fullFileName.substr(fullFileName.lastIndexOf('.'));

    const parsedString = awsCredentials.fields.key.substring(0, awsCredentials.fields.key.lastIndexOf('/') + 1);
    awsCredentials.fields.key = parsedString + Date.now() + fileExtension;
    const s3FormData = new FormData();
    Object.keys(awsCredentials.fields).forEach(field => {
        s3FormData.append(field.toString(), awsCredentials.fields[field]);
    });
    s3FormData.append('Content-Type', contentType);
    s3FormData.append('file', b64toBlob(filePayload, contentType));

    const url = awsCredentials.url;
    api = configAxiosFormData(url);
    const { data } = await api.post('', s3FormData);
    const s3Return = xml2json(data);
    return {
        name: fullFileName,
        path: appendAbsolutePath(s3Return.PostResponse.Key)
    };
};

export const formatBase64 = base64File => {
    const fileAuxArray = base64File.split(',');
    fileAuxArray.shift();
    return fileAuxArray.join();
};

export const getFileMime = base64File => {
    const fileAuxArray = base64File.split(',');
    const contentType = fileAuxArray[0].split(';')[0].split(':')[1];
    return contentType;
};

export const appendAbsolutePath = path => {
    if (path.indexOf('/') == 0) {
        return path;
    }
    return '/' + path;
};

// return {
//     saveFiles: saveFiles,
// };
// };
